var _rect, _rect2, _circle, _path, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 400,
    viewBox: "0 0 500 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 400,
    rx: 12,
    fill: "#f8f9fa"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50,
    width: 400,
    height: 300,
    rx: 8,
    fill: "#ffffff",
    stroke: "#e0e0e0",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 150,
    r: 70,
    fill: "#e8f5e9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220 150 L240 170 L280 130",
    stroke: "#2e7d32",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 250,
    width: 300,
    height: 20,
    rx: 10,
    fill: "#e0e0e0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 280,
    width: 200,
    height: 20,
    rx: 10,
    fill: "#e0e0e0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 310,
    width: 140,
    height: 20,
    rx: 10,
    fill: "#e0e0e0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroImage);
export default __webpack_public_path__ + "static/media/hero-image.b25758518dae78352d3c3a141e275bfe.svg";
export { ForwardRef as ReactComponent };